<template>
  <div class="info-block">
    <IconBase name="info_icon" class="info-block__icon" />
    <div class="info-block__content">
      <ArticleContentRenderer :content="text" :preloaded-data="preloadedData" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import ArticleContentRenderer from '@/features/articleContent/ArticleContentRenderer.vue';
import type { PreloadedData } from '@/features/articleContent/lib/articleComponents';
import type { ArticleContent } from '@/features/articleContent/models/ArticleContent';
import IconBase from '@/shared/ui/iconBase/IconBase.vue';

defineProps<{
  text: ArticleContent;
  preloadedData?: PreloadedData;
}>();
</script>

<style lang="scss" scoped>
.info-block {
  display: flex;
  gap: 12px;
  max-width: 805px;
  padding: 20px 16px;
  margin-top: 24px;
  background-color: var(--alias-color-background-subtler);
  border-radius: 10px;
}

.info-block__content {
  flex: 1;
  min-width: 0;

  :deep(> *) {
    padding-top: 0;
    margin-top: 0;
  }
}
</style>
